import Button from '../../../components/base/Button';

export default function CTASection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
          Looking for the Best Digital Media Support Service? Look No Further!
        </h2>
        <p className="text-lg text-gray-600 mb-8 leading-relaxed">
          Our exceptional prices and features are genuine! As digital media support specialists, we offer a 100% Satisfaction Guarantee or Your Money Back. We're confident in our service and ready to prove it, ensuring you take no risks but enjoy immense rewards. Upgrade your entertainment experience with us and enjoy unparalleled satisfaction. Don't delay – transform your home entertainment system today with Goodys Streams!
        </p>
        <Button href="https://wa.me/qr/QOVGSHQTONIKJ1" size="lg">
          GET PREMIUM
        </Button>
      </div>
    </section>
  );
}
